export const SIGN_UP = "[Auth Action] sign up user";

// token actions
export const TOKEN_FOUND_BY_ADDRESS = "token found by address";

// setting actions
export const TRANSACTION_SPEED_SET = "set the transaction speed in GWEI";
export const SLIPPAGE_TOLERANCE_SET = "set the slippage tolerance in percent";
export const TRANSACTION_DEADLINE_SET = "set the transaction deadline in mins";
export const AUDIO_TRANSACTION_SET = "set the transaction audio";

// token price actions
export const TALLY_PRICE_GET = "get the tally price from the pancakeswap API";